import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "value", "maxlength"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    class: _normalizeClass(["lg:text-sm text-xs", $props.theme]),
    type: $props.type,
    value: $props.value,
    maxlength: $props.maxlength,
    onInput: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleInput($event.target.value)))
  }, null, 42, _hoisted_1))
}